import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const QUICK = ["New Zealand", "United Kingdom"];
const SUGGESTIONS = ["Ireland", "South Africa", "United States", "Canada", "India", "Philippines", "Fiji",
  "Germany", "France", "Netherlands", "Singapore", "Hong Kong", "Japan", "South Korea", "China", "Vietnam",
  "Indonesia", "Malaysia", "Nepal", "Sri Lanka", "Brazil", "Argentina", "Chile", "Spain", "Italy", "Sweden"];

export const RelocatingFromDialog = ({ open, onOpenChange, onSelect }) => {
  const [query, setQuery] = useState("");
  const matches = query.trim()
    ? SUGGESTIONS.filter((c) => c.toLowerCase().includes(query.trim().toLowerCase())).slice(0, 5)
    : [];
  const choose = (c) => {
    onSelect(c);
    setQuery("");
    onOpenChange(false);
  };
  const submitTyped = () => {
    const val = query.trim();
    if (val) choose(val.charAt(0).toUpperCase() + val.slice(1));
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#fcfbf8] max-w-md" data-testid="relocating-from-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-[#0d2f4d]">Where are you relocating from?</DialogTitle>
          <DialogDescription className="text-[#51637a]">
            We help people move from anywhere — Kiwis and Brits are our specialty.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {QUICK.map((c) => (
            <button key={c} type="button" onClick={() => choose(c)}
              data-testid={`from-quick-${c.toLowerCase().replace(/ /g, "-")}`}
              className="rounded-lg border border-[#e3e0d3] bg-white px-4 py-4 text-sm font-heading font-bold text-[#0d2f4d] hover:border-[#C1CC24] hover:bg-[#C1CC24]/10 transition-colors">
              {c === "New Zealand" ? "🇳🇿 New Zealand" : "🇬🇧 United Kingdom"}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <div className="h-px flex-1 bg-[#e3e0d3]" />
          <span className="text-xs text-[#51637a] uppercase tracking-[0.15em]">or somewhere else</span>
          <div className="h-px flex-1 bg-[#e3e0d3]" />
        </div>
        <div>
          <input value={query} onChange={(e) => setQuery(e.target.value)} data-testid="from-country-input"
            placeholder="Type your country" autoFocus={false}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); submitTyped(); } }}
            className="w-full rounded-lg border border-[#e3e0d3] bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#94a01a]" />
          {matches.length > 0 && (
            <div className="mt-2 space-y-1">
              {matches.map((c) => (
                <button key={c} type="button" onClick={() => choose(c)} data-testid={`from-suggestion-${c.toLowerCase().replace(/ /g, "-")}`}
                  className="block w-full text-left rounded-md px-3 py-2 text-sm text-[#0d2f4d] hover:bg-[#C1CC24]/15 transition-colors">
                  {c}
                </button>
              ))}
            </div>
          )}
          <button type="button" onClick={submitTyped} disabled={!query.trim()} data-testid="from-country-continue"
            className="mt-3 w-full rounded-full bg-[#0d2f4d] text-white text-sm font-medium py-3 hover:bg-[#1c4d78] transition-colors disabled:opacity-40">
            Continue
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
